module.exports = __webpack_public_path__ + "static/img/s4.48411dc0.png";